import axios from 'axios'
import { ApiConfig } from '../../config/api'
import {
  AsnBlogCreate,
  AsnDetailReceiveLpn,
  AsnDetailReceiveLpnPatch,
  AsnReceiveFilters
} from './Interfaces'

export const getAsnToReceive = (filters: AsnReceiveFilters) => {
  const url = new URL(`${ApiConfig.AsnReceiveLpnApi}/GetAsnToReceive`)
  if (filters.asnNumber) url.searchParams.set('asnNumber', filters.asnNumber)
  if (filters.asnId) url.searchParams.set('asnId', filters.asnId.toString())
  if (filters.lpn) url.searchParams.set('lpn', filters.lpn)
  if (filters.sku) url.searchParams.set('sku', filters.sku)
  if (filters.supplierId)
    url.searchParams.set('supplierId', filters.supplierId.toString())
  if (filters.supplierOriginId)
    url.searchParams.set(
      'supplierOriginId',
      filters.supplierOriginId.toString()
    )
  return axios.get(url.toString())
}

export const getAsnToReceiveById = (asnId: number) => {
  const url = new URL(
    `${ApiConfig.AsnReceiveLpnApi}/GetAsnToReceiveById/${asnId}`
  )
  return axios.get(url.toString())
}

export const patchReceivedLPN = (
  asnId: number,
  lpn: AsnDetailReceiveLpnPatch
) => {
  const url = new URL(`${ApiConfig.AsnReceiveLpnApi}/ReceiveLpn/${asnId}`)
  return axios.patch(url.toString(), lpn)
}

export const getListLpn = (asnId: number, filters: AsnDetailReceiveLpn) => {
  const url = new URL(`${ApiConfig.AsnReceiveLpnApi}`)
  url.searchParams.set('asnId', asnId.toString())
  if (filters.lpnReceived != undefined) {
    url.searchParams.set('lpnReceived', filters.lpnReceived.toString())
  }
  return axios.get(url.toString())
}

export const postAsnBlog = (asnBlog: AsnBlogCreate) => {
  const url = new URL(`${ApiConfig.AsnBlogApi}`)
  return axios.post(url.toString(), asnBlog)
}

export const patchCancelReception = (asnId: number, asnBlog: AsnBlogCreate) => {
  const url = new URL(`${ApiConfig.AsnReceiveLpnApi}/CancelReception/${asnId}`)
  return axios.patch(url.toString(), asnBlog)
}

export const patchReceiveWithDifferences = (
  asnId: number,
  asnBlog: AsnBlogCreate
) => {
  const url = new URL(
    `${ApiConfig.AsnReceiveLpnApi}/ReceiveWithDifferences/${asnId}`
  )
  return axios.patch(url.toString(), asnBlog)
}

export const getIboundSuppliers = () => {
  const url = `${ApiConfig.InboundSearchApi}/Suppliers`
  return axios.get(url)
}

export const getIboundOrigins = async () => {
  const url = `${ApiConfig.InboundSearchApi}/Origins`
  return axios.get(url)
}
